import { LwApiPM } from "@techniaorg/liteweb-api";
import { modelPathOnServer, waitForIFrame } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrame(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_open(p: any) {
  let url = modelPathOnServer + p;
  (document.getElementById("output") as HTMLTextAreaElement).value = "";

  LwAPI?.openModel(url).then((result) => {
    (document.getElementById("output") as HTMLTextAreaElement).value =
      JSON.stringify(result, null, " ");
    if (result.error !== null) alert(result.msg);
  });
}

// Bind functions to buttons
document.getElementById("open1")?.addEventListener("click", async () => {
  await apiReady;
  ex_open("Measurement.jt");
});
document.getElementById("open2")?.addEventListener("click", async () => {
  await apiReady;
  ex_open("Flange.jt");
});
document.getElementById("open3")?.addEventListener("click", async () => {
  await apiReady;
  ex_open("_123_.jt");
});
